import {
    CustomsInformation,
    FuelType,
    ModelCategory,
    VehicleDimensions,
    VehicleId,
    VehicleType,
} from '../../sharedComponents/common.types';
import { parseOptionalStringDate } from '../../sharedComponents/dateHelper';
import {
    ApiCategory,
    ApiCustomsInformation,
    ApiFuelType,
    ApiVehicleDimensions,
    ApiVehicleId,
    ApiVehicleType,
} from '../types/sharedVehicleApi.types';
import { NonEmptyString } from 'io-ts-types';

export const mapToVehicleDimensions = (apiDimension: ApiVehicleDimensions): VehicleDimensions => ({
    length: apiDimension.length,
    width: apiDimension.width,
    height: apiDimension.height,
});

export const mapToApiVehicleId = (vehicleId: VehicleId): ApiVehicleId => ({
    vin: vehicleId.vin as NonEmptyString,
    production_number: vehicleId.productionNumber as NonEmptyString,
});

export const mapToVehicleId = (apiVehicleId: ApiVehicleId): VehicleId => {
    return {
        vin: apiVehicleId.vin,
        productionNumber: apiVehicleId.production_number,
    };
};

export const mapToCustomsInformation = (apiCustomsInformation: ApiCustomsInformation): CustomsInformation => ({
    customsReferenceNumber: apiCustomsInformation.customs_reference_number,
    customsReferenceNumberIssuedAt: parseOptionalStringDate(apiCustomsInformation.customs_reference_number_issued_at),
});

export const mapToCategory = (apiCategory: ApiCategory): ModelCategory => {
    switch (apiCategory) {
        case ApiCategory.CAMPER_VAN:
            return ModelCategory.CAMPER_VAN;
        case ApiCategory.CAR:
            return ModelCategory.CAR;
        case ApiCategory.MOTORCYCLE:
            return ModelCategory.MOTORCYCLE;
        case ApiCategory.QUAD:
            return ModelCategory.QUAD;
        case ApiCategory.SPECIAL_VEHICLE:
            return ModelCategory.SPECIAL_VEHICLE;
        case ApiCategory.TRIKE:
            return ModelCategory.TRIKE;
        case ApiCategory.TRUCK:
            return ModelCategory.TRUCK;
        case ApiCategory.VAN:
            return ModelCategory.VAN;
    }
};

export const mapToFuelType = (apiFuelType: ApiFuelType): FuelType => {
    switch (apiFuelType) {
        case ApiFuelType.COMPRESSED_NATURAL_GAS:
            return FuelType.COMPRESSED_NATURAL_GAS;
        case ApiFuelType.DIESEL:
            return FuelType.DIESEL;
        case ApiFuelType.DIESEL_ELECTRIC:
            return FuelType.DIESEL_ELECTRIC;
        case ApiFuelType.ELECTRIC:
            return FuelType.ELECTRIC;
        case ApiFuelType.HYDROGEN:
            return FuelType.HYDROGEN;
        case ApiFuelType.LIQUID_NATURAL_GAS:
            return FuelType.LIQUID_NATURAL_GAS;
        case ApiFuelType.LIQUID_PROPANE_GAS:
            return FuelType.LIQUID_PROPANE_GAS;
        case ApiFuelType.PETROL:
            return FuelType.PETROL;
        case ApiFuelType.PETROL_ELECTRIC:
            return FuelType.PETROL_ELECTRIC;
    }
};

export const mapToVehicleType = (apiVehicleType: ApiVehicleType): VehicleType => {
    switch (apiVehicleType) {
        case ApiVehicleType.NEW:
            return VehicleType.NEW;
        case ApiVehicleType.USED:
            return VehicleType.USED;
        case ApiVehicleType.OTHER:
            return VehicleType.OTHER;
    }
};

export const mapToApiVehicleType = (vehicleType: VehicleType): ApiVehicleType => {
    switch (vehicleType) {
        case VehicleType.NEW:
            return ApiVehicleType.NEW;
        case VehicleType.USED:
            return ApiVehicleType.USED;
        case VehicleType.OTHER:
            return ApiVehicleType.OTHER;
    }
};
